import { getSession } from 'utility/Session'
import { STORE_PARTNER } from './action'

const initialState = {
  partner: getSession('ago-partner'),
}

export default function partnerReducer(state = initialState, action) {
  switch (action.type) {
    case STORE_PARTNER:
      return {
        ...state,
        partner: action.data,
      }
    default:
      return state
  }
}
